type RequestHeadersProvider = () => Record<string, string> | undefined;

export const TERRA_REQUEST_HEADER_ALLOWLIST = [
  'x-terra-ai-eval-overlay',
  'x-correlation-id',
] as const;

let provider: RequestHeadersProvider | null = null;

export function getTerraRequestHeaders(): Record<string, string> {
  const headers = provider?.() ?? {};
  return Object.fromEntries(
    Object.entries(headers).filter(([name]) =>
      (TERRA_REQUEST_HEADER_ALLOWLIST as readonly string[]).includes(
        name.toLowerCase(),
      ),
    ),
  );
}

export function getTerraRequestHeadersProvider(): RequestHeadersProvider | null {
  return provider;
}

export function setTerraRequestHeadersProvider(
  fn: RequestHeadersProvider | null,
): void {
  provider = fn;
}
